module.exports = __webpack_public_path__ + "static/img/1-2.b7fa77c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/1-2.png
// module id = H1V6
// module chunks = 0